import { render, staticRenderFns } from "./privteB.vue?vue&type=template&id=e771e804&scoped=true&"
import script from "./privteB.vue?vue&type=script&lang=js&"
export * from "./privteB.vue?vue&type=script&lang=js&"
import style0 from "./privteB.vue?vue&type=style&index=0&id=e771e804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e771e804",
  null
  
)

export default component.exports